module.exports = __webpack_public_path__ + "img/fuyoushantuanjian.7976e530.png";